import React from 'react';
import { ControlTitle } from './controlTitle';
import { ControlError } from './controlError';

export const DateControl = ({ title, defaultValue, Component, componentData: cd, readonly, onBlur, onChange, error }) => {
    return (
        <div className="form-item">
            <ControlTitle title={title} />
            <Component
                onBlur={newValue => onBlur(newValue)}
                onChange={onChange}
                defaultValue={defaultValue}
                placeholder={cd.placeHolder}
                readonly={readonly}
                {...(cd.minWidth && {minWidth : cd.minWidth})}
                {...(cd.width && {width : cd.width})}
                {...(cd.maxWidth && {maxWidth : cd.maxWidth})}
            />
            <ControlError error={error} />
        </div>
    );
}